
import { Component, OnInit, Inject } from '@angular/core';
import { EventEditHistoryService } from '../../services/event-edit-history.service';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommentRendererComponent } from 'src/app/core/grid-renderer/comment.grid-renderer';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-event-edit-history',
  templateUrl: './event-edit-history.component.html',
  styleUrls: ['./event-edit-history.component.scss'],
  standalone: false // NOSONAR
})
export class EventEditHistoryComponent implements OnInit {


  eventId: any;
  res: [];
  currentPage1: number;
  totalPageNm1: number;
  successMessage: any;
  errorMessage: any;
  public gridApi: any;
  public domLayout: any = '';
  defaultColDef: {};
  icons: {};
  columnDefs = [

    { headerName: 'EVENT TYPE', field: 'eventtype', minWidth: 100, maxWidth: 130, },
    { headerName: 'U/L', field: 'ul', minWidth: 130, maxWidth: 130, valueFormatter: this.dateFormatter, },
    { headerName: 'ROUTE', field: 'route', minWidth: 90, maxWidth: 100, },
    { headerName: 'STATUS', field: 'status', minWidth: 90, maxWidth: 100, },
    {
      headerName: 'PROBLEM TYPE', field: 'problemType', minWidth: 210, maxWidth: 220, cellStyle: { cursor: 'pointer' },
      cellRendererFramework: CommentRendererComponent,
    },
    { headerName: 'LOGISTICS PARTNER', field: 'logisticsPartner', minWidth: 150, maxWidth: 170, },
    { headerName: 'ETA', field: 'eta', minWidth: 130, maxWidth: 120, valueFormatter: this.dateFormatter, },
    { headerName: 'TRAILER', field: 'trailer', minWidth: 70, maxWidth: 90, },
    {
      headerName: '  COMMENTS', field: 'comments', minWidth: 280, maxWidth: 410, cellStyle: { cursor: 'pointer' },
      cellRendererFramework: CommentRendererComponent,
    },
    { headerName: 'LAST UPDATED DATE', field: 'lastUpdatedDate', minWidth: 130, maxWidth: 150, valueFormatter: this.dateFormatter, },
    { headerName: 'LAST UPDATED BY', field: 'lastUpdatedBy', minWidth: 100, maxWidth: 120, }
  ];

  rowData: any[] = [];
  paginationPageSize: any = 10;
  displayRowData: any[] = [];
  rowCount1: number = 0;
  isLastPageFound!: boolean;
  totalPage: number = 0;
  currentPageForTotalPage!: number;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  rowClassRules: { 'row-even': string; 'row-odd': string; };


  constructor(public dialogRef: MatDialogRef<EventEditHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly EventEditHistoryService: EventEditHistoryService,
    private readonly ngxUiLoaderService: NgxUiLoaderService) {

    this.defaultColDef = {
      suppressMovable: true,
      wrapText: true,
      wrapHeaderText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      suppressHorizontalScroll: true,
    }

    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }

  ngOnInit(): void {
    if (localStorage.getItem('eventId')) {
      this.eventId = localStorage.getItem('eventId');
    }
    this.loadData();
  }

  dateFormatter(params) {
    return params.value ? moment(params.value).format('MM/DD/YYYY HH:mm') : null;
  }

  loadData() {
    this.successMessage = null;
    this.errorMessage = null;
    this.rowData = [];
    this.ngxUiLoaderService.start('loader-1');
    this.EventEditHistoryService.loadEventEditHistory(this.eventId).subscribe(res => {
      this.ngxUiLoaderService.stop('loader-1');
      const tableData = res;
      const typeMap = new Map<number, string>();
      typeMap.set(1, 'BlowOut');
      typeMap.set(2, 'Late Route');
      typeMap.set(3, 'Shortage');
      typeMap.set(4, 'Preemptive');
      typeMap.set(5, 'Dropped Route');
      typeMap.set(9, 'Out of Plan');
      typeMap.set(10, 'Misconnects');
      typeMap.set(11, 'Missed Unload');
      typeMap.set(12, 'Returns Recovery');

      const statusMap = new Map<string, string>();
      statusMap.set('A', 'Arrived');
      statusMap.set('B', 'Broken Route');
      statusMap.set('C', 'Covered');
      statusMap.set('F', 'Confirmed');
      statusMap.set('N', 'Not Covered');
      statusMap.set('O', 'In Progress');
      statusMap.set('P', 'Partial Route');
      statusMap.set('T', 'In Transit');
      statusMap.set('X', 'Closed');
      statusMap.set('D', 'Deleted');
      statusMap.set('E', 'New');

      const problemMap = new Map<number, string>();
      problemMap.set(46, 'Accident in route');
      problemMap.set(45, 'Off route returns');
      problemMap.set(1, 'No Driver - HOS');
      problemMap.set(2, 'No Driver - Call In');
      problemMap.set(3, 'Supplier Closed/Disruption');
      problemMap.set(4, 'Supplier Delay');
      problemMap.set(5, 'Road Closure/Disruption');
      problemMap.set(6, 'Equipment Unavailable');
      problemMap.set(7, 'Equipment Breakdown');
      problemMap.set(9, 'Border Delay');
      problemMap.set(10, 'Over Weight');
      problemMap.set(12, 'Port Delay');
      problemMap.set(13, 'Not found at subroute unload');
      problemMap.set(14, 'NAMC Request');
      problemMap.set(15, 'Weather');
      problemMap.set(16, 'Supplier Shortage');
      problemMap.set(19, 'Urgent Supplement');
      problemMap.set(20, 'Non-Urgent Supplement');
      problemMap.set(21, 'Dispatch late');
      problemMap.set(22, 'Yard arrival late');
      problemMap.set(23, 'Held at supplier dock');
      problemMap.set(24, 'Missed supplier window time');
      problemMap.set(25, 'Traffic Delay');
      problemMap.set(26, 'Weather Delay');
      problemMap.set(27, 'Dropped Route');
      problemMap.set(28, 'Dock-locked at supplier');
      problemMap.set(29, 'TEMA Request');
      problemMap.set(30, 'Cubeout');
      problemMap.set(31, 'Shortage at SR Unload');
      problemMap.set(32, 'Missed SR Unload');
      problemMap.set(33, 'Will not make MR Reload');
      problemMap.set(34, 'Will not make Shuttle Unload');
      problemMap.set(35, 'Will not make NAMC Unload');
      problemMap.set(36, 'Due to blowout');
      problemMap.set(37, 'Period changeover');
      problemMap.set(38, 'Not found at mainroute reload');
      problemMap.set(39, 'Freight already picked up');
      problemMap.set(40, 'Freight shipped on wrong route');
      problemMap.set(41, 'Returns recovery');
      problemMap.set(42, 'Freight shipped ahead');
      problemMap.set(43, 'Late arrival freight');
      problemMap.set(44, 'Drive Delay');

      const vendorMap = new Map<number, string>();
      vendorMap.set(462, 'Best Logistics Group');
      vendorMap.set(1, 'Transfreight');
      vendorMap.set(2, 'Carter');
      vendorMap.set(3, 'Ascent');
      vendorMap.set(4, 'Challenger');
      vendorMap.set(5, 'Hero Logistics');
      vendorMap.set(6, 'KC Transport');
      vendorMap.set(7, 'NYK Logistics');
      vendorMap.set(8, 'Online');
      vendorMap.set(9, 'OWL');
      vendorMap.set(12, 'Rush');
      vendorMap.set(13, 'Russell');
      vendorMap.set(14, 'Tsusho');
      vendorMap.set(15, 'West Tenn. Exp');
      vendorMap.set(16, 'Vascor');
      vendorMap.set(42, 'XPO Logistics');
      vendorMap.set(21, 'Ryder');
      vendorMap.set(81, 'Magnolia');
      vendorMap.set(17, 'Help Logistics');
      vendorMap.set(18, 'C.H. Robinson');
      vendorMap.set(401, 'STG Logistics');
      vendorMap.set(141, 'Penske');
      vendorMap.set(221, 'Black Horse Carriers');
      vendorMap.set(301, 'WW Rowland');
      vendorMap.set(261, 'Transportes Aralo');
      vendorMap.set(441, 'J.B. Hunt');
      vendorMap.set(241, 'Fletes Mexico');
      vendorMap.set(281, 'Autolineas America');
      vendorMap.set(321, 'Spartan Carrier Group');



      tableData.forEach(row => {
        let status = '';
        let problemType = '';
        let logisticsPartner = '';
        let eventtype = '';

        if (row) {
          status = statusMap.get(row.statusId) ?? '';
          problemType = problemMap.get(row.problemTypeId) ?? '';
          logisticsPartner = vendorMap.get(row.transportationProviderId) ?? '';
          eventtype = typeMap.get(row.eventTypeId) ?? '';
        }

        const obj = {
          //changetype: row.changeType == 'D' ? row.changeType = 'DELETED' : row.changeType = '',
          eventtype,
          ul: row ? row.arrival : '',
          route: row ? row.puRoute : '',
          status,
          problemType,
          logisticsPartner,
          eta: row ? row.eta : '',
          trailer: row ? row.eventTrailer : '',
          comments: row ? row.comments : '',
          lastUpdatedDate: row ? row.lastUpdated : '',
          lastUpdatedBy: row ? row.lastUpdatedBy : ''
          //deleteddate: row.data ? (row.data?.last_updated ? row.data?.last_updated : row.data?.lastUpdated) : '',
          //deletedby: row.data ? (row.data?.last_updated_by ? row.data?.last_updated_by : row.data?.lastUpdatedBy) : ''
        };
        this.rowData.push(obj);
      });
      this.rowData = [...this.rowData];
      this.rowCount1 = this.rowData.length;
    },
      err => {
        this.ngxUiLoaderService.stop('loader-1');
        console.info(err);
      });
  }
  cellStyle(_params: any) {
    return { 'display': 'flex', 'justify-content': 'center', 'background-color': '#D20000', 'color': '#FFFFFF', 'border-radius': '25px', 'margin': '0 10px', 'max-width': 'fit-content', 'font-size': '11px', 'height': '20px' };
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit() }
  goToNexpage() { this.gridApi?.paginationGoToNextPage() }
  goToPreviousPage() { this.gridApi?.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi?.paginationGoToFirstPage() }
  goToLastPage() { this.gridApi?.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") {  // NOSONAR
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(this.rowData.length));
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }

  onPaginationChanged() {

    if (this.gridApi!) {
      this.setText('#lbCurrentPage1', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages1', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }

  setText(selector: string, text: any) {

    if (this.rowCount1 > 0) {

      (document.querySelector(selector) as any).innerHTML = text;
      if (selector == '#lbCurrentPage1') {  // NOSONAR
        this.currentPage1 = text
      }
      else {
        this.totalPageNm1 = text;
      }
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }

  /* onGridReady(params:any) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  } */

}
